




































































import { PreCollectionsParams } from '@/resource/pre-collection/pre-collection.store';
import { Component, Prop, Vue } from 'vue-property-decorator';
import FilterLevel from '@/main-components/pre-collections-new/pre-collection-filter/FilterLevel.vue';
import FilterType from '@/main-components/pre-collections-new/pre-collection-filter/FilterType.vue';
import FilterYear from '@/main-components/pre-collections-new/pre-collection-filter/FilterYear.vue';
import MainButton from '@/main-components/common/MainButton.vue';

@Component({
  components: {
    FilterLevel,
    FilterType,
    FilterYear,
    MainButton,
  },
})
export default class PreCollectionFilter extends Vue {
  @Prop({ required: true })
  queries!: PreCollectionsParams;

  submitFilter(isChangeQuery: boolean) {
    this.$emit('reFetch', isChangeQuery);
  }

  showFilter = false;

  // Dummy data used by a watch decorator to reset filter
  filterReset = false;

  screenWidth = window.innerWidth;

  async created() {
    window.addEventListener('resize', this.handleResize);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    this.screenWidth = window.innerWidth;
  }

  openFilter() {
    this.showFilter = true;
  }

  closeFilter() {
    this.showFilter = false;
  }

  resetFilter() {
    this.filterReset = !this.filterReset;
    this.$emit('resetFilters');
  }
}
